export const STORAGE_KEYS = {
  LAST_BROWSED_PATH: 'lastBrowsed',
  MONDAY_URL: 'monday-url',
} as const;
